import { yupResolver } from '@hookform/resolvers/yup'
import { Auth } from 'aws-amplify'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

import Button, { ButtonVariant } from '@/components/button'
import Link from '@/components/link'
import Input from '@/components/input'
import getQueryParam from '@/utils/get-query-param'
import handleApiError from '@/utils/handle-api-error'

const schema = object({
  email: string().email().required(),
}).required()

const RequestCode = ({ toggleHasCode, updateSubmittedEmail }) => {
  const defaultEmail = getQueryParam('email') || ''

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { email: defaultEmail },
  })

  const onSubmit = useCallback(
    ({ email }) => {
      Auth.forgotPassword(email)
        .then(() => {
          updateSubmittedEmail(email)
          toggleHasCode(true)
        })
        .catch(handleApiError)
    },
    [toggleHasCode, updateSubmittedEmail],
  )

  return (
    <div className='relative'>
      <div className='py-4'>
        <form
          className='auth-form mt-[50px] flex flex-col items-end space-y-2'
          onSubmit={handleSubmit(onSubmit)}
        >
          <Input
            name='email'
            label='Registered Email'
            type='email'
            autoComplete='email'
            required
            register={register}
            errors={errors}
          />

          <div className='flex w-full items-center justify-between pt-2'>
            <div className='text-sm'>
              <Link href='/auth/login' className='custom-font22 text-[#E2846F]'>
                try logging in again
              </Link>
            </div>
            <Button
              type='submit'
              variant={ButtonVariant.Primary}
              bg='bg-white'
              tailFill='white'
              className='custom-font22 w-fit px-5 py-1.5'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[40%]'
            >
              Get Reset Code
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RequestCode

RequestCode.propTypes = {
  toggleHasCode: PropTypes.string.isRequired,
  updateSubmittedEmail: PropTypes.string.isRequired,
}
